module.exports = __webpack_public_path__ + "static/media/468x60_0053_ro.0a32aeb8.png";